'use client';

import { BlogI18n } from '@/lib/i18n/blogI18n';

const BlogPagination = ({
  page,
  totalPages,
  onGoToPage,
  t,
}: BlogPaginationProps) => {
  if (totalPages <= 1) return null;

  return (
    <div className="mt-12 flex items-center justify-center gap-1">
      <PaginationButton
        onClick={() => onGoToPage(page - 1)}
        disabled={page === 1}
        aria-label={t.previousPage}
      >
        ←
      </PaginationButton>

      {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
        <PaginationButton
          key={p}
          onClick={() => onGoToPage(p)}
          active={p === page}
        >
          {p}
        </PaginationButton>
      ))}

      <PaginationButton
        onClick={() => onGoToPage(page + 1)}
        disabled={page === totalPages}
        aria-label={t.nextPage}
      >
        →
      </PaginationButton>
    </div>
  );
};

export default BlogPagination;

type BlogPaginationProps = {
  page: number;
  totalPages: number;
  onGoToPage: (p: number) => void;
  t: BlogI18n;
};

const PaginationButton = ({
  children,
  active,
  disabled,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { active?: boolean }) => (
  <button
    disabled={disabled}
    className={`w-12 h-12 text-sm rounded-xs transition-colors cursor-pointer
      ${active ? 'bg-primary text-white font-semibold' : 'text-text-secondary hover:text-primary hover:bg-surface'}
      ${disabled ? 'opacity-30 cursor-not-allowed' : ''}
    `}
    {...props}
  >
    {children}
  </button>
);
